import { useFeatureFlagsGet } from '@/api';
import { FeatureFlagInfoDto } from '@/api/base/model/feature-flag-info-dto';
import { Spinner, useLoading } from '@/components';
import { removeStyledSmallScreenProp, useSmallScreen } from '@/utils';
import { Box, Card, CardContent, CardHeader, styled, Switch, Typography } from '@mui/material';

export const FeatureFlags = () => {
  const { loading, hideLoading } = useLoading();
  const { data, isFetching } = useFeatureFlagsGet();
  const smallScreen = useSmallScreen();

  return loading || isFetching ? (
    <Spinner fullSize={true} />
  ) : data ? (
    <Container smallScreen={smallScreen}>
      {data.featureFlags.map((x) => (
        <FeatureFlagInfo key={x.name} {...x} />
      ))}
    </Container>
  ) : (
    <></>
  );
};

const FeatureFlagInfo = (data: FeatureFlagInfoDto) => {
  return (
    <Card style={{ maxWidth: '250px', margin: '5px' }}>
      <CardHeader
        disableTypography={true}
        style={{ fontWeight: 'bold', overflowWrap: 'anywhere' }}
        title={data.name}
      />
      <CardContent style={{ fontSize: '0.8em' }}>
        Enabled:&nbsp;
        <Switch checked={data.isEnabled} disabled={true} />
        <p>{data.description}</p>
        <GroupList title='Users:' items={data.usersFilter} />
        <GroupList title='Companies:' items={data.groupsFilter} />
      </CardContent>
    </Card>
  );
};

const GroupList = ({ title, items }: { title: string; items: string[] }) => {
  return items.length > 0 ? (
    <>
      <b>{title}</b>
      <ul>
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </>
  ) : (
    <></>
  );
};

const Container = styled(
  Box,
  removeStyledSmallScreenProp,
)<{ smallScreen: boolean }>(({ theme, smallScreen }) => ({
  padding: smallScreen ? `${theme.spacing(6)} ${theme.spacing(2)}` : theme.spacing(8),
  display: 'flex',
  flexWrap: 'wrap',
}));
